/**
 * @generated SignedSource<<162f72d6123c26d447db349bedf08a02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SaveSearchButton_viewer$data = {
  readonly followSearchRedesign: boolean | null;
  readonly " $fragmentType": "SaveSearchButton_viewer";
};
export type SaveSearchButton_viewer$key = {
  readonly " $data"?: SaveSearchButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SaveSearchButton_viewer",
  "selections": [
    {
      "alias": "followSearchRedesign",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "followSearchRedesign"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"followSearchRedesign\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5a1d8e3bd2b54f8d95af2fbbd1bcd75b";

export default node;
